import React, { Component } from "react";
import PropTypes from "prop-types";
import { TouchableHighlight, View } from "react-native";
import Text from "../TextFont";
import * as CONSTANTS from "../../../assets/consts";
import Spinner from "../Spinner";
import { IconButton } from "../Buttons";
import * as faCharCodes from "../../../assets/consts/faCharCodes";
import Switch from "../../components/ToggleSwitch";
import * as DeviceTypes from "../../components/devices/_deviceTypes";
import Theme from "../../argon-ui/Theme";
import { HStack, VStack } from "native-base";
import LogIconButton from "../LogIconButton";
import { getDir } from "../../util";
class RBSheetInnerDeviceItem extends Component {
  static propTypes = {
    isKioskMode: PropTypes.bool,
    text: PropTypes.string.isRequired,
    hint: PropTypes.string,
    batteryLevel: PropTypes.number,
    icon: PropTypes.string,
    customIcon: PropTypes.any,
    iconStyle: PropTypes.shape(),
    iconColor: PropTypes.string,
    hasReport: PropTypes.bool,
    deviceType: PropTypes.string,
    deviceId: PropTypes.number,
    value: PropTypes.any,
    onTextPress: PropTypes.func,
    onIconPress: PropTypes.func,
    onReportPress: PropTypes.func,
    loadingTimeOut: PropTypes.number,
    ignoreEventLoading: PropTypes.number,
    isActive: PropTypes.bool,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      nextProps.deviceType == DeviceTypes.MOTION_SENSOR &&
      nextProps.value == true &&
      nextProps.onMovementDetection
    ) {
      nextProps.onMovementDetection();
    }

    if (nextProps.value != prevState.currentValue && prevState.isLoading) {
      if (prevState.ignoreEventLoading > 0) {
        return {
          ignoreEventLoading: prevState.ignoreEventLoading - 1,
          currentValue: nextProps.value,
        };
      } else {
        return { isLoading: false, currentValue: nextProps.value };
      }
    }

    return null;
  }
  constructor(props) {
    super(props);
    this.state = {
      currentValue: this.props.value,
      ignoreEventLoading: this.props.ignoreEventLoading || 0,
      isLoading: false,
    };
  }

  handleOnIconPress = () => {
    if (this.props.value != undefined && this.props.loadingTimeOut != 0) {
      this.setState(
        {
          isLoading: true,
          ignoreEventLoading: this.props.ignoreEventLoading || 0,
        },
        () => {
          setTimeout(() => {
            if (this.state.isLoading && !this.state.ignoreEventLoading) {
              // just release loader if not changed yet by device event
              this.setState({ isLoading: false });
            }
          }, Number(this.props.loadingTimeOut) || 5000);
        }
      );
    }

    this.props.onIconPress && this.props.onIconPress();
  };

  handleOnTextPress = () => {
    if (this.props.onTextPress) {
      this.props.onTextPress();
    } else {
      this.handleOnIconPress();
    }
  };

  handleOnReportPress = () => {
    this.props.onReportPress && this.props.onReportPress();
  };

  renderActionButton = () => {
    let _iconStyle = this.props.iconStyle || {};
    if (this.state.isLoading) return <Spinner />;

    let _icon = null;
    if (!this.props.isActive) {
      _icon = (
        <IconButton
          style={{
            width: 50,
            borderRadius: 25,
            paddingTop: 8,
          }}
          //onPress={this.handleOnIconPress}
          icon={{
            code: faCharCodes.faExclamationTriangle,
            style: {
              fontFamily: faCharCodes.FONT_FAMILIES.PRO_LIGHT,
              fontSize: 26,
              color: "#666666",
              ..._iconStyle,
            },
          }}
        />
      );
    } else if (this.props.customIcon != undefined) {
      _icon = this.props.customIcon;
    } else if (this.props.icon == undefined) {
      _icon = (
        <Switch
          isOn={this.props.value}
          onColor={Theme.COLORS.ACTIVE}
          offColor={Theme.COLORS.MUTED}
          //label="Example label"
          //labelStyle={{ color: "black", fontWeight: "900" }}
          size="small"
          onToggle={this.handleOnIconPress}
          animationSpeed={0}
        />
      );
    } else {
      _icon = (
        <IconButton
          style={{
            width: 50,
            borderRadius: 25,
            paddingTop: 8,
          }}
          onPress={this.handleOnIconPress}
          icon={{
            code: this.props.icon,
            style: {
              fontFamily: faCharCodes.FONT_FAMILIES.PRO_LIGHT,
              fontSize: 26,
              color:
                this.props.batteryLevel != null &&
                this.props.batteryLevel <= CONSTANTS.WARNING_MIN_BATTERY
                  ? Theme.COLORS.ERROR
                  : this.props.iconColor || "#666666",
              ..._iconStyle,
            },
          }}
        />
      );
    }

    return (
      <View>
        {_icon}
        {/** batteryLevel */}
        {this.props.batteryLevel != null &&
          this.props.batteryLevel <= CONSTANTS.WARNING_MIN_BATTERY && (
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <Text
                style={{
                  color: Theme.COLORS.ERROR,
                  fontSize: 10,
                  paddingTop: 3,
                  paddingHorizontal: 5,
                }}
              >
                {this.props.batteryLevel}%
              </Text>
              <IconButton
                style={{
                  width: 20,
                  borderRadius: 10,
                  paddingTop: 4,
                }}
                icon={{
                  code: faCharCodes.faBatteryQuarter,
                  style: {
                    fontFamily: "FontAwesomeProLight",
                    fontSize: 15,
                    color: Theme.COLORS.ERROR,
                  },
                }}
              />
            </View>
          )}
      </View>
    );
  };

  render() {
    if (this.props.isKioskMode) {
      return (
        <TouchableHighlight
          underlayColor={Theme.COLORS.LIGHT_MAIN}
          onPress={this.handleOnTextPress}
          style={[
            {
              maxWidth: 220,
              minWidth: 210,
              // maxWidth: 310,
              // minWidth: 250,
              flex: 1,
              padding: 10,
              borderRadius: 10,
              borderWidth: 3,
              borderColor: Theme.COLORS.AREA_ITEM_BORDER,
              backgroundColor: Theme.COLORS.AREA_ITEM_BACKGROUND,
              // height: 65,
              direction: getDir(),
              marginBottom: 12,

              // shadowColor: Theme.COLORS.BACKGROUND,
              // shadowOffset: {
              //   width: 0,
              //   height: 3,
              // },
              // shadowOpacity: 0.2,
              // shadowRadius: 6.65,
              // elevation: 4,
            },
          ]}
        >
          <VStack space="2.5">
            <HStack space="3.5">
              {this.props.hasReport === true && (
                <LogIconButton onPress={this.handleOnReportPress} />
              )}
              <View
                style={{
                  alignItems: "flex-start",
                  flex: 1,
                  justifyContent: "center",
                  flexDirection: "row",
                }}
              >
                <Text
                  onPress={this.handleOnTextPress}
                  ellipsizeMode="middle"
                  numberOfLines={1}
                  style={{
                    fontSize: 14,
                    // paddingTop: 12,
                    //paddingBottom: 8,
                    color: "#666666",
                    paddingVertical: 10,
                    flex: 1,
                    alignItems: "flex-start",
                  }}
                >
                  {this.props.text}
                </Text>
                <Text
                  style={{
                    fontSize: 16,
                    paddingTop: 20,
                    color: "#aaaaaa",
                    alignItems: "flex-end",
                  }}
                >
                  {this.props.hint}
                </Text>
              </View>
            </HStack>
            <HStack justifyContent="flex-end" alignItems="flex-end">
              {(this.props.icon != "" ||
                this.props.customIcon != undefined) && (
                <View
                  style={{
                    width: this.props.customIcon == undefined ? 60 : 120,
                    height: 60,
                    alignItems: "center",
                    alignContent: "center",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  {this.props.statusColor && (
                    <View
                      style={{
                        width: 8,
                        height: 8,
                        borderRadius: 4,
                        backgroundColor: this.props.statusColor,
                        position: "absolute",
                        top: 5,
                        right: 3,
                        shadowColor: this.props.statusColor,
                        shadowOffset: {
                          width: 0,
                          height: 5,
                        },
                        shadowOpacity: 0.2,
                        shadowRadius: 5.62,
                        elevation: 7,
                      }}
                    />
                  )}
                  {this.renderActionButton()}
                </View>
              )}
            </HStack>
          </VStack>
        </TouchableHighlight>
      );
    }
    return (
      <HStack
        space="2.5"
        style={[
          {
            flexDirection: "row",
            justifyContent: "space-around",
            borderBottomColor: "#eee",
            alignItems: "center",
            borderBottomWidth: 1,
            marginStart: 10,
            marginEnd: 10,
            flex: 1,
            // height: 65,
            direction: getDir(),
          },
        ]}
      >
        {this.props.hasReport === true && (
          <LogIconButton onPress={this.handleOnReportPress} />
        )}
        <TouchableHighlight
          underlayColor={Theme.COLORS.WHITE}
          onPress={this.handleOnTextPress}
          style={{
            alignItems: "flex-start",
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "row",
            borderRadius: 10,
          }}
        >
          <>
            <Text
              ellipsizeMode="middle"
              numberOfLines={1}
              style={{
                fontSize: 16,
                // paddingTop: 12,
                //paddingBottom: 8,
                color: "#666666",
                paddingVertical: 10,
                flex: 1,
                alignItems: "flex-start",
              }}
            >
              {this.props.text}
            </Text>
            <Text
              style={{
                fontSize: 16,
                paddingTop: 20,
                color: "#aaaaaa",

                alignItems: "flex-end",
              }}
            >
              {this.props.hint}
            </Text>
            {(this.props.icon != "" || this.props.customIcon != undefined) && (
              <View
                style={{
                  width: this.props.customIcon == undefined ? 60 : 120,
                  height: 60,
                  alignItems: "center",
                  alignContent: "center",
                  justifyContent: "center",
                  position: "relative",
                }}
              >
                {this.props.statusColor && (
                  <View
                    style={{
                      width: 8,
                      height: 8,
                      borderRadius: 4,
                      backgroundColor: this.props.statusColor,
                      position: "absolute",
                      top: 5,
                      right: 3,
                      shadowColor: this.props.statusColor,
                      shadowOffset: {
                        width: 0,
                        height: 5,
                      },
                      shadowOpacity: 0.2,
                      shadowRadius: 5.62,
                      elevation: 7,
                    }}
                  />
                )}
                {this.renderActionButton()}
              </View>
            )}
          </>
        </TouchableHighlight>
      </HStack>
    );
  }
}
export default RBSheetInnerDeviceItem;
